import { DeltaStatus } from './constants.js';

function getLineArrayDelta(data) {
  const lastPrice = data[0].value;
  const price = data[data.length - 1].value;
  return {
    delta: price - lastPrice,
    lastPrice,
    price
  };
}
const getCandleDelta = data => {
  return data.close - data.open;
};
function getCandleArrayDelta(data) {
  const lastPrice = (data[0].close + data[0].close) / 2;
  const price = (data[data.length - 1].close + data[data.length - 1].close) / 2;
  return {
    delta: price - lastPrice,
    lastPrice: lastPrice,
    price: price
  };
}
const emptyDeltaData = {
  delta: 0,
  percentage: '0.00',
  status: DeltaStatus.neutral
};
function getDeltaFromChartData(data, variant, formatPrice, tradingPair) {
  if (data.length === 0) {
    return {
      label: `${formatPrice ? formatPrice(0, tradingPair) : Intl.NumberFormat().format(0)} (0.00%)`,
      ...emptyDeltaData
    };
  }
  const {
    delta,
    lastPrice,
    price
  } = variant === 'line' ? getLineArrayDelta(data) : getCandleArrayDelta(data);
  const formattedPrice = formatPrice ? formatPrice(delta, tradingPair) : Intl.NumberFormat().format(delta);
  if (lastPrice === price) {
    return {
      label: `${formattedPrice} (0.00%)`,
      ...emptyDeltaData
    };
  }
  const percentage = (delta / lastPrice * 100).toFixed(2);
  return {
    delta,
    label: `${formattedPrice} (${percentage}%)`,
    percentage,
    status: delta > 0 ? DeltaStatus.positive : DeltaStatus.negative
  };
}
function getFormattedCandleData(candle, formatPrice, tradingPair) {
  const delta = getCandleDelta(candle);
  const percentage = (delta / candle.close * 100).toFixed(2);
  return {
    deltaLabel: `${formatPrice(delta, tradingPair)} (${percentage}%)`,
    candle: {
      time: candle.time,
      open: formatPrice(candle.open, tradingPair),
      high: formatPrice(candle.high, tradingPair),
      low: formatPrice(candle.low, tradingPair),
      close: formatPrice(candle.close, tradingPair)
    }
  };
}
const DeltaUtils = {
  getDeltaFromChartData,
  getFormattedCandleData,
  getCandleArrayDelta,
  getLineArrayDelta
};

export { DeltaUtils };
